import { CardHeader } from '@mui/material';
import {
  CcfCard,
  CcfFavouriteIcon,
  CCfToggleIconButton,
  CcfTypography,
} from '@nice-ccf/ui-controls';
import styles from './ccf-quick-reply-card.module.scss';
import {
  QuickReply,
  updateSelectedQReply,
  updatePreviewQuickReply,
  toggleFavQuickReply,
} from '../../ccf-app-space.slice';
import { useDispatch } from 'react-redux';

/* eslint-disable-next-line */
export interface CcfQuickReplyCardProps {
  reply: QuickReply;
  index: number;
}

/**
 * CcfQuickReplyCard - used to disply reply card in quick replies section
 * @param props - CcfQuickReplyCardProps
 * @example `<CcfQuickReplyCard reply=QuickReply index=number />`
 */
export function CcfQuickReplyCard(props: CcfQuickReplyCardProps) {
  const dispatch = useDispatch();

  /**
   * selectedCard - used to select the reply to preview and send to media interaction
   * @param e - React.MouseEvent
   * @param reply - QuickReply
   * @example selectedCard(e, reply)
   */
  const selectedCard = (e: React.MouseEvent, reply: QuickReply) => {
    dispatch(updateSelectedQReply(reply));
    dispatch(updatePreviewQuickReply(true));
  };

  return (
    <CcfCard
      key={`quick-reply-${props.index}`}
      className={styles.replyCard}
      onClick={(event) => {
        selectedCard(event, props.reply);
      }}
    >
      <CardHeader
        action={
          <CCfToggleIconButton
            className={styles.favButton}
            onClick={() => dispatch(toggleFavQuickReply(props.reply))}
            icon={<CcfFavouriteIcon className={styles.favReply} />}
            isToggled={props.reply.isfavorite}
            size="small"
            toggleIcon={<CcfFavouriteIcon className={styles.nonFavReply} />}
          />
        }
        classes={{
          root: styles.quickReplyHeader,
          title: styles.quickReplyTitle,
        }}
        id="agent_appSpace_quickReplyHeader"
        title={props.reply.title}
      />
      <CcfTypography variant="body2" className={styles.replyContent}>
        {props.reply.content1}
        {props.reply.content2}
      </CcfTypography>
    </CcfCard>
  );
}

export default CcfQuickReplyCard;
